module.exports = __webpack_public_path__ + "img/sun-haze.3ef5afbd.svg";